import { useState, useEffect } from "react";

/**
 * Custom hook for managing character count with validation limits
 *
 * @param {string} watchedValue - The value to watch for changes
 * @param {number} maxLength - Maximum number of characters allowed
 * @returns {Object} Character count state and utility functions
 */
export function useCharacterCount(watchedValue, maxLength) {
  const [characterCount, setCharacterCount] = useState(() => {
    return watchedValue ? watchedValue.length : 0;
  });

  // Update character count when watched value changes
  useEffect(() => {
    const count = watchedValue ? watchedValue.length : 0;
    setCharacterCount(count);
  }, [watchedValue]);

  // Calculate limit states
  const isNearLimit = characterCount > maxLength * 0.8; // 80% of limit
  const isAtLimit = characterCount >= maxLength;

  return {
    characterCount,
    isNearLimit,
    isAtLimit,
    setCharacterCount,
  };
}
